<!-- <button mat-button class="close-icon" [mat-dialog-close]="true">
        X
</button> -->
<div>
        <img *ngIf="data[data[0].index].linkUrl == ''" [src]="data[data[0].index].imageUrl" height="400">
    <a href="{{data[data[0].index].linkUrl}}">
        <img *ngIf="data[data[0].index].linkUrl != ''" [src]="data[data[0].index].imageUrl" height="400" >
    </a>
</div>